// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-wrapper[data-v-1f585826]{border-left:.156vw solid #e96b5a;padding-left:.521vw}", ""]);
// Exports
module.exports = exports;
